import axios from "axios";
import { Cloud_API_URL } from "../../utils/constants";

const apiClient = axios.create({
  baseURL: Cloud_API_URL,
  timeout: 5000,
  headers: {
    "Content-Type": "application/json"
  }
});

export default apiClient;